import { Outlet } from 'react-router-dom';
import { DesktopHeader } from '@/components/navigation/DesktopHeader';
import { Sidebar } from '@/components/navigation/Sidebar';
import styles from './DesktopLayout.module.css';

export function DesktopLayout() {
  return (
    <div className={styles.page}>
      <div className={styles.row}>
        <Sidebar />
        <div className={styles.mainColumn}>
          <DesktopHeader />
          <main className={styles.main}>
            <div className={styles.mainInner}>
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
